import React, { useState } from 'react'
import filter from 'lodash/fp/filter'
import Add from 'components/ui/Add'
import useChores from './Chores.use'
import ChoresCard from './ChoresCard'
import ChoresModal from './ChoresModal'

const Chores = () => {
  const [showModal, setShowModal] = useState(false)
  const [selectedChore, setSelectedChore] = useState(null)
  const {
    chores,
    kids,
    options,
    error,
    fetching,
    addChore,
    editChore,
    removeChore,
  } = useChores()

  const onAddBtnClicked = () => {
    setSelectedChore(null)
    setShowModal(true)
  }

  const onCardClicked = (chore) => {
    setSelectedChore(chore)
    setShowModal(true)
  }

  if (fetching) {
    return <span>Loading...</span>
  }

  if (error) {
    return <span>Oops! Reload and try again.</span>
  }

  return (
    <div className="flex flex-wrap pt-4 -mx-2">
      <Add onClick={onAddBtnClicked} className="absolute top-0 right-0 mr-4 -mt-6" />

      {chores.length && kids.length ? (
        kids.map((kid) => {
          const choresByKid = filter({ kidId: kid.id }, chores)

          return (
            <div key={kid.id} className="w-full mb-4">
              <div className="px-2 pb-2 text-2xl">{kid.name}</div>
              <div className="flex flex-wrap">
                {choresByKid.map((chore) => (
                  <div key={chore.id} className="w-1/3 px-2 mb-4 min-h-32">
                    <ChoresCard
                      chore={chore}
                      options={options}
                      callback={onCardClicked}
                    />
                  </div>
                ))}
              </div>
            </div>
          )
        })
      ) : (
        <div>No chores yet. Let's add some!</div>
      )}

      {showModal && (
        <ChoresModal
          chore={selectedChore}
          options={options}
          setShow={setShowModal}
          callbacks={{
            add: addChore,
            edit: editChore,
            remove: removeChore,
          }}
        />
      )}
    </div>
  )
}

export default Chores
